'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_navigation_IconButton_IconButton = require('../../navigation/IconButton/IconButton.cjs.js');

const Styles = {
  root: react.css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
  `
};
const DateRangePickerNavbar = ({ onNextClick, onPreviousClick }) => {
  return react.jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    react.jsx(components_navigation_IconButton_IconButton.IconButton, { icon: "arrowSmallLeft", label: "Previous Month", onClick: () => onPreviousClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southwest", color: "icon-tertiary" }),
    react.jsx(components_navigation_IconButton_IconButton.IconButton, { icon: "arrowSmallRight", label: "Next Month", onClick: () => onNextClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southeast", color: "icon-tertiary" })
  );
};

exports.DateRangePickerNavbar = DateRangePickerNavbar;
//# sourceMappingURL=DateRangePickerNavbar.cjs.js.map
